import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { PatAssessmentQuestionnaireItem } from './questionnaire'
import { PATIENT_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/PatientBackground'
import { MODIFIER_A_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/ModifierA'
import { BRADEN_SCALE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/BradenScale'
import { MODIFIER_B_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/ModifierB'
import { ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/AssessmentOverview'
import { CNA_SKILLED_TASKS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/CNASkilledTasks'
import { SCORE_AND_SUMMARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/ScoreAndSummary'

export const PAT_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  // Assessment overview
  ...ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Patient background
  ...PATIENT_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Modifier A
  ...MODIFIER_A_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Braden Scale - using section-level mapping to avoid duplication
  ...BRADEN_SCALE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Modifier B - using section-level mapping to avoid duplication
  ...MODIFIER_B_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // CNA Skilled Tasks
  ...CNA_SKILLED_TASKS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Scores
  ...SCORE_AND_SUMMARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Next steps
  [PatAssessmentQuestionnaireItem.NEXT_STEPS_FINAL_NOTES]: QuestionnaireAnswerType.STRING,
  [PatAssessmentQuestionnaireItem.NEXT_STEPS_QUALIFICATION_STATUS]: QuestionnaireAnswerType.CODING,
  [PatAssessmentQuestionnaireItem.NEXT_STEPS_REQUESTED_DOCS]: QuestionnaireAnswerType.CODING,
  [PatAssessmentQuestionnaireItem.NEXT_STEPS_SPECIFIC_NEEDS_FOR_DOCS]:
    QuestionnaireAnswerType.CODING,
  [PatAssessmentQuestionnaireItem.NEXT_STEPS_QA]: QuestionnaireAnswerType.CODING
}
